import axios from "axios";
import { findGetParameter } from "../global";
import store from ".";

const usuarioStore = {
  namespaced: true,
  state: {
    usuarioLogado: null,
    drawer: true,
    tabConta: 0,
    gerencial: false,
    loadingApp: true,
    modulos: [],
    pendencias: null,
  },
  getters: {
    /*
    ========================================
    GETTER QUESTIONÁRIO DE DESLIGAMENTO DESABILITADO
    ========================================
    Solicitação do RH - ID-2440
    Motivo: Desabilitar temporariamente o questionário de desligamento
    
    Código original comentado abaixo:
    */
    /*
    shouldShowQuestionarioDesligamento: (state) => {
      const pendencias = state.pendencias;
      if (!pendencias) return false;

      // Verifica se tem data de desligamento E se ainda não respondeu o questionário
      const temDataDesligamento =
        pendencias.dat_desligamento != null &&
        pendencias.dat_desligamento != "";
      const naoRespondeuQuestionario =
        !pendencias.registro_existe_resp_questionario;

      console.log("🎯 WEB: Verificando condições do questionário:");
      console.log("   - Tem data de desligamento?", temDataDesligamento);
      console.log("   - Não respondeu questionário?", naoRespondeuQuestionario);
      console.log("   - Data desligamento:", pendencias.dat_desligamento);
      console.log(
        "   - Registro existe:",
        pendencias.registro_existe_resp_questionario
      );

      return temDataDesligamento && naoRespondeuQuestionario;
    },
    */

    // Getter temporariamente desabilitado - sempre retorna false
    shouldShowQuestionarioDesligamento: () => {
      return false; // Desabilitado conforme solicitação RH ID-2440
    },
  },
  mutations: {
    setUsuarioLogado(state, user) {
      state.usuarioLogado = user;
    },
    setDrawer(state, drawer) {
      state.drawer = drawer;
    },
    setTabConta(state, tab) {
      state.tabConta = tab;
    },
    setGerencial(state, ger) {
      state.gerencial = ger;
    },
    setLoadingApp(state, value) {
      state.loadingApp = value;
    },
    setModulos(state, value) {
      state.modulos = value;
    },
    setPendencias(state, value) {
      state.pendencias = value;
    },
  },
  actions: {
    async validarToken(context) {
      var token = findGetParameter("token");
      if (token != "" && token != null) {
        sessionStorage.setItem("userKey", token);
        context.commit("setGerencial", true);
      }

      context.commit("setUsuarioLogado", null);
      await axios
        .get("/colaborador/valida-token", {
          validateStatus: function () {
            return true;
          },
        })
        .then(async (res) => {
          if (res.data.success) {
            context.commit("setUsuarioLogado", res.data.data);
            if (context.state.modulos.length == 0) {
              await context.dispatch("getModulos");
            }
          }
        });
    },
    async getModulos(context) {
      context.commit("setModulos", []);
      await axios.get(`/colaborador/modulos`).then((res) => {
        if (res.data.success) {
          context.commit("setModulos", res.data.data);
        }
      });
    },
    logout() {
      sessionStorage.removeItem("userKey");
    },
    async getPendencias(context) {
      context.commit("setPendencias", null);
      await axios.get("/colaborador/pendencias-colaborador").then((res) => {
        if (res.data.success) {
          context.commit("setPendencias", res.data.data);
          if (context.state.pendencias.msg_aviso_senha_compra_prazo != "") {
            store.commit("configComprasPrazo/setDialogAviso", true);
          } else {
            store.commit("configComprasPrazo/setDialogAviso", false);
          }
        }
      });
    },
  },
};

export default usuarioStore;
